import { render, staticRenderFns } from "./terminalnum-batch-send-messages-modal.vue?vue&type=template&id=df8d8cd2&scoped=true"
import script from "./terminalnum-batch-send-messages-modal.vue?vue&type=script&lang=js"
export * from "./terminalnum-batch-send-messages-modal.vue?vue&type=script&lang=js"
import style0 from "./terminalnum-batch-send-messages-modal.vue?vue&type=style&index=0&id=df8d8cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8d8cd2",
  null
  
)

export default component.exports